import React from 'react';
import {
  StyleSheet,
  Text,
  BaseInput,
  View,
  resolveStyle,
} from '../components/base_components';

const styles = StyleSheet.create({
  radio: { flexDirection: 'row', marginBottom: '0.5rem' },
  text: {
    marginLeft: '0.5rem',
    color: 'var(--input-text-color)',
    fontSize: '1.35rem',
  },
  disabledText: { color: 'var(--input-disabled-color)' },
});

type Props = {
  style?: any;
  value: string;
  options: any;
  name?: any;
  disabled?: boolean;
  onChange: (value: string) => void;
};
export default function RadioList(props: Props) {
  const { value, options, disabled, ...other } = props;

  const opts = options.map((opt: any, i: number) => {
    let opt_value;
    let text;
    if (typeof opt === 'string') {
      opt_value = opt;
      text = opt;
    } else {
      opt_value = opt.value;
      text = opt.text;
    }
    return (
      <Radio
        key={i}
        value={opt_value}
        text={text}
        selected={value === opt_value}
        disabled={disabled || opt?.disabled}
        default={opt?.default}
        {...other}
      />
    );
  });
  return <>{opts}</>;
}
function Radio(props: any) {
  const { style, selected, disabled, class: extraClass } = props;
  const { className, inlineStyle } = resolveStyle(style, extraClass);

  function _onChange() {
    props.onChange(props.value);
  }
  const extra: any = {};
  if (selected) {
    extra.checked = 'checked';
  } else {
    extra.checked = '';
  }

  return (
    <View style={[styles.radio, props.style]}>
      <label
        className={'base-component-text-input ' + className}
        style={inlineStyle}
      >
        <BaseInput
          type='radio'
          disabled={disabled}
          value={props.value}
          onChange={_onChange}
          {...extra}
        />
        <Text
          style={[
            styles.text,
            disabled ? styles.disabledText : null,
            props.textStyle,
          ]}
        >
          {props.text}
        </Text>
      </label>
    </View>
  );
}
